export default ({ touched, error }: { touched?: any; error?: string }) => {
  const state = touched ? (error ? 'error' : 'valid') : 'default';
  const errorMsg = touched ? error : undefined;

  return { error: errorMsg, state };
};
